<template>
	<Modal v-if="shown"
		   :title= titleText
		   @close="show(false)"
		   :close-on-click-outside="false"
		   :width="820"
	>
		<template v-slot:body>
			<div class="flex flex_between md-group">
				<md-button class="flex_1" :class="{'md-primary': activeType === activeTypes.debtorData}"
						   @click="changeActiveType(activeTypes.debtorData)">
					{{ $t("debtorManagement.overview.debtorInformation") }}
				</md-button>
				<md-button class="flex_1" :class="{'md-primary': activeType === activeTypes.debtorContacts}"
						   @click="changeActiveType(activeTypes.debtorContacts)">
					{{ $t("debtorManagement.overview.debtorContact") }}
				</md-button>
				<md-button class="flex_1" :class="{'md-primary': activeType === activeTypes.creditManagement}"
						   @click="changeActiveType(activeTypes.creditManagement)">
					{{ $t("debtorManagement.overview.creditManagement") }}
				</md-button>
				<md-button class="flex_1" :class="{'md-primary': activeType === activeTypes.debtorDocuments}"
						   @click="changeActiveType(activeTypes.debtorDocuments)">
					{{ $t("debtorManagement.overview.uploadDocument") }}
				</md-button>
			</div>
			<DebtorData v-show="activeType === activeTypes.debtorData"
						ref="debtorData"
						:relation-data="relationData"
						@next="changeActiveType(activeTypes.debtorContacts)"
						@review-relation="confirmSubmitRelationToReview"
						@relation-changed="debtorSupplierRelationChanged"
						@close="show(false)"
			></DebtorData>
			<DebtorContacts v-show="activeType === activeTypes.debtorContacts"
							ref="debtorContacts"
							:debtor-id="relationData ? relationData.debtorId : null"
							@next="changeActiveType(activeTypes.creditManagement)"
							@close="show(false)"
			></DebtorContacts>
			<CreditManagement v-show="activeType === activeTypes.creditManagement"
							  ref="creditManagement"
							  :relation-id="relationData ? relationData.id : null"
							  @next="changeActiveType(activeTypes.debtorDocuments)"
							  @relation-changed="debtorSupplierRelationChanged"
							  @close="show(false)"
			></CreditManagement>
			<DebtorDocuments v-show="activeType === activeTypes.debtorDocuments"
							 ref="debtorDocuments"
							 :relation-id="relationData ? relationData.id : null"
							 @relation-changed="debtorSupplierRelationChanged"
							 @submit-relation="confirmSubmitRelation"
							 @review-relation="confirmSubmitRelationToReview"
							 @close="show(false)"
			></DebtorDocuments>
		</template>
	</Modal>
</template>

<script>

import Modal from "src/components/templates/modal/Modal";
import DebtorData from "src/components/templates/seller/debtorManagement/DebtorData";
import DebtorContacts from "src/components/templates/seller/debtorManagement/DebtorContacts";
import CreditManagement from "src/components/templates/seller/debtorManagement/CreditManagement";
import DebtorDocuments from "src/components/templates/seller/debtorManagement/DebtorDocuments";
import {debtorManagementApi} from "src/common/api/debtorManagementApi";

export default {
	components: {
		CreditManagement,
		DebtorContacts,
		DebtorData,
		DebtorDocuments,
		Modal,
	},
	data() {
		let activeTypes = {
			debtorData: "debtor",
			debtorContacts: "contacts",
			creditManagement: "creditManagement",
			debtorDocuments: "documents",
		};

		return {
			editMode: false,
			shown: false,
			activeTypes: activeTypes,
			activeType: activeTypes.debtorData,
			relationData: null,
		};
	},
	computed: {
		titleText() {
			return this.editMode ? this.debtorName : this.$t("debtorManagement.overview.addDebtor")
		}
	},
	methods: {
		show(value) {
			this.shown = value;
		},
		showRelationModal() {
			this.show(true);
			this.editMode = false;
			this.activeType = this.activeTypes.debtorData;
			this.relationData = null;
		},
		showDebtorDetails(data) {
			this.show(true);
			this.editMode = true;
			this.activeType = this.activeTypes.debtorData;
			this.relationData = data;
		},
		showDebtorContacts(data) {
			this.show(true);
			this.editMode = true;
			this.activeType = this.activeTypes.debtorContacts;
			this.relationData = data;
		},
		showCreditManagement(data) {
			this.show(true);
			this.editMode = true;
			this.activeType = this.activeTypes.creditManagement;
			this.relationData = data;
		},
		showDebtorDocuments(data) {
			this.show(true);
			this.editMode = true;
			this.activeType = this.activeTypes.debtorDocuments;
			this.relationData = data;
		},
		changeActiveType(type) {
			if (this.editMode) {
				this.activeType = type;
				return;
			}

			if (this.activeType === this.activeTypes.debtorData) {
				if (type === this.activeTypes.debtorContacts || type === this.activeTypes.creditManagement || type === this.activeTypes.debtorDocuments) {
					this.$refs.debtorData.validate()
						.then(() => {
							debtorManagementApi.inspection.debtorCheck(this.$refs.debtorData.getData())
								.then(res => {
									let checkSuccessful = true;

									if (res.debtorAlreadyAdded) {
										checkSuccessful = false;
										this.toast(this.$t("debtorManagement.addDebtor.checkDebtorData.debtorAlreadyAdded"));
										this.$emit("close");
									} else if (res.existingDebtor) {
										this.$refs.debtorData.changeDebtor(res.existingDebtor)

										if (res.debtorDataMismatch) {
											checkSuccessful = false;
											this.toast(this.$t("debtorManagement.addDebtor.checkDebtorData.debtorDataMismatch"), "warning");
										}
									}

									if (checkSuccessful) {
										this.activeType = type;
									}
								}).catch(this.toast);
						})
				}
			} else {
				this.activeType = type;
			}
		},
		confirmSubmitRelation() {
			let option = {
				title: this.$t("debtorManagement.addDebtor.confirm.title"),
				msg: this.$t("debtorManagement.addDebtor.confirm.text"),
				confirmFun: this.submitRelation
			};
			this.confirmMeg(option, true);
		},
		submitRelation() {
			let params = this.buildRelationData();
			debtorManagementApi.operation.addBusinessRelation(params)
				.then((res) => {
					this.toastSuccess();
					this.debtorSupplierRelationChanged(params.id === null, res);
				}).catch(this.toast);
		},
		confirmSubmitRelationToReview() {
			let option = {
				title: this.$t("debtorManagement.reviewDebtor.confirm.title"),
				msg: this.$t("debtorManagement.reviewDebtor.confirm.text"),
				confirmFun: this.submitRelationToReview
			};
			this.confirmMeg(option, true);
		},
		submitRelationToReview() {
			let params = this.buildRelationData();
			debtorManagementApi.operation.submitBusinessRelation(params)
				.then((res) => {
					this.toastSuccess();
					this.debtorSupplierRelationChanged(params.id === null, res);
				}).catch(this.toast);
		},
		debtorSupplierRelationChanged(forNewRelation = false, addedDebtorResult) {
			this.show(false);
			this.$emit('change', forNewRelation, addedDebtorResult);
		},
		buildRelationData() {
			let debtorData = {
				...this.$refs.debtorData.getData()
			};

			return {
				id: this.relationData ? this.relationData.id : null,
				debtor: debtorData,
				contacts: this.$refs.debtorContacts.getData(),
				credits: this.$refs.creditManagement.getData(),
				documents: this.$refs.debtorDocuments.getData()
			};
		}
	},
};
</script>